const esquemaCampos = {
  ticket: {valor: '', error: ''},
  estado: {valor: 0, error: ''},  
};

const esquemaValidacion = {
  ticket: {
    requerido: true
  },  
  estado: {
    requerido: false,
    validador: {
      cast: valor => {
        return parseInt(valor);
      }
    }
  },  
};

module.exports = {
  esquemaCampos,
  esquemaValidacion
  //esquemaQuery,
};
